export const circuitos2 = {
	c0: {
		y: "Por carretera",
		lng: '10 etapas'
	},
	c20: {
      y: "Jerez - Le Mans",
		lng: '1.685 km'
	},
	c40: {
		y: "Le Mans - Mugello",
		lng: '1.300 km'
	},
	c60: {
		y: "Mugello - Catalunya",
		lng: '1.172 km'
	},
	c80: {
		y: "Catalunya - Assen",
		lng: '1.612 km'
	},
	c100: {
		y: "Assen - Sachsenring",
		lng: '314 km'
	},
	c120: {
		y: "Sachsenring - Brno",
		lng: '893 km'
	},
	c140: {
		y: "Brno - Austria",
		lng: '346 km'
	},
	c160: {
		y: "Austria - Silverstone",
		lng: '1.501 km'
	},
	c180: {
		y: "Silverstone - Misano",
		lng: '1.757 km'
	},
	c200: {
		y: "Misano - Aragón",
		lng: '1.555 km'
	}
};



// WEBPACK FOOTER //
// ./src/data/circuitos2.js